import { render, staticRenderFns } from "./CategoriesButton.vue?vue&type=template&id=81881620&"
import script from "./CategoriesButton.vue?vue&type=script&lang=js&"
export * from "./CategoriesButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports